import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage overline="Documento legal" title="Termos de Utilização">
      <p>
        Os presentes Termos regulam a utilização do site suapiscinapt.com e do serviço de simulação visual de piscinas residenciais nele disponibilizado. Ao submeter um pedido de simulação, o proprietário aceita estes termos.
      </p>

      <h2>Natureza do serviço</h2>
      <p>
        O Sua Piscina PT é um estúdio de visualização residencial. Preparamos uma simulação visual e uma estimativa indicativa de investimento, sem qualquer compromisso de obra. O Sua Piscina PT não executa obras, não vende piscinas e não representa legalmente instaladores. A relação de serviço é exclusivamente de visualização e mediação de contacto.
      </p>

      <h2>Estimativa de investimento</h2>
      <p>
        A estimativa apresentada é meramente indicativa, baseada em ordens de grandeza típicas do mercado português. Não substitui visita técnica ao local, orçamento formal por parte de instalador, verificação de viabilidade de licenciamento, análise do terreno, acessos, equipamentos necessários ou qualquer outro elemento determinante do custo real. O orçamento final é sempre apresentado pelo instalador parceiro após avaliação presencial.
      </p>

      <h2>Relação com instaladores parceiros</h2>
      <p>
        Trabalhamos com uma rede curada de instaladores acreditados. Quando o proprietário decide avançar, fazemos a introdução directa. A relação contratual de obra é estabelecida exclusivamente entre o proprietário e o instalador escolhido, sem qualquer intervenção ou responsabilidade do Sua Piscina PT nessa relação.
      </p>

      <h2>Conteúdos e propriedade intelectual</h2>
      <p>
        Todos os conteúdos, simulações e materiais visuais produzidos pelo Sua Piscina PT são propriedade do estúdio. As simulações enviadas ao proprietário podem ser utilizadas livremente para fins pessoais e para discussão com instaladores.
      </p>

      <h2>Limitação de responsabilidade</h2>
      <p>
        O Sua Piscina PT não se responsabiliza por decisões de investimento tomadas com base apenas na simulação visual ou na estimativa indicativa. Recomendamos sempre confirmar viabilidade técnica, custos reais de licenciamento e orçamento formal com o instalador antes de qualquer decisão.
      </p>

      <h2>Lei aplicável</h2>
      <p>
        Os presentes Termos são regulados pela lei portuguesa. Em caso de litígio, é competente o foro da comarca de Lisboa.
      </p>
    </LegalPage>
  );
}
